import { HERO } from "@/content/copy";
import { trackEvent } from "@/lib/analytics";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-terracotta-light blur-3xl opacity-60" />
        <div className="absolute top-40 -left-32 w-80 h-80 rounded-full bg-navy/5 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="max-w-3xl">
          <p data-testid="hero-overline" className="text-sm font-bold uppercase tracking-widest text-terracotta animate-fade-in-up">
            {HERO.overline}
          </p>
          <h1
            data-testid="hero-headline"
            className="mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight font-extrabold text-navy animate-fade-in-up"
            style={{ animationDelay: "0.1s" }}
          >
            {HERO.headline}
          </h1>
          <p
            data-testid="hero-subheadline"
            className="mt-6 text-lg sm:text-xl text-navy/70 leading-relaxed animate-fade-in-up"
            style={{ animationDelay: "0.2s" }}
          >
            {HERO.subheadline}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
            <a
              href="#book"
              data-testid="hero-book-consultation-button"
              onClick={() => trackEvent("book_consultation_click", { location: "hero" })}
              className="inline-flex justify-center items-center rounded-full bg-terracotta px-8 py-4 text-base font-bold text-white transition-all duration-300 hover:bg-terracotta-hover hover:-translate-y-0.5 hover:shadow-lg focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 focus-visible:outline-none"
            >
              {HERO.primaryCta}
            </a>
            <a
              href="#checklist"
              data-testid="hero-checklist-button"
              className="inline-flex justify-center items-center rounded-full border-2 border-navy px-8 py-4 text-base font-bold text-navy transition-all duration-300 hover:bg-navy hover:text-white focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:outline-none"
            >
              {HERO.secondaryCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
